import React from "react";
import { Nutrical } from "../../models/Neutrical";
import CardCotainer, { Card } from "../../ui-elements/CardContainer/CardContainer";
import { UserTypeE } from "../UserType/UserType";
import "./Goal.scss";

import looseWeightImage from '../../assets/loose-weight.png';
import gainMuscleImage from '../../assets/build-muscle.png';
import bodyRecomp from '../../assets/body-recomp.png';
import { AnalyticsApi } from "../../api/user";

interface GoalProp {
	nutrical: Nutrical;
	valueSelected(response?: any): void;
}

const Goal: React.FC<GoalProp> = ({ nutrical, valueSelected }): JSX.Element => {
	const goal = nutrical.goal;
	const [selectedIndex, setSelectedIndex] = React.useState(typeof goal.reachGoal !== "undefined" ? goal.reachGoal : -1);
	const [enabled, setEnabled] = React.useState(false);
	const goals: Card[] = [
		{
			index: 0,
			imageUrl: looseWeightImage,
			title: "Lose Weight",
			body: `${nutrical.userType === UserTypeE.Client ? "They'd" : "You'd"} like to lose at least 10 to 15 pounds (or more).`,
			extendedBody: "We'll calculate an eating plan that's designed to help you achieve your desired weight loss by the date you specify. <br><br>Keep in mind, weight loss is best achieved by a comprehensive program that includes resistance training, cardiovascular exercise, restorative activity (such as yoga), quality sleep, and stress management. <br><br>The recommendations we provide to reach this goal are an educated starting point. See your Complete Results PDF - available once your data has been calculated - for more guidance"
		},
		{
			index: 1,
			imageUrl: gainMuscleImage,
			title: "Build Muscle",
			body: `${nutrical.userType === UserTypeE.Client ? "They'd" : "You'd"} like to build muscle and increase your overall body weight.`,
			extendedBody: "This eating plan will help you gain muscle and overall body weight. Fair warning: You'll likely gain some fat as you build mass. (It's part of the tradeoff for getting bigger.)<br><br>To achieve your desired results, you'll need to perform rigorous resistance training. And for optimal progress, you'll also want to include appropriate levels of conditioning work and restorative activity (like yoga), along with quality sleep and stress management.<br><br>See your Complete Results PDF - available once your data has been calculated - for more guidance."
		},
		// {
		// 	index: 2,
		// 	imageUrl: "https://www.precisionnutrition.com/hand_portion_calculator/assets/images/goal-athleticperformance.svg",
		// 	title: "Athletic Performance",
		// 	body: `${nutrical.userType === UserTypeE.Client ? "They" : "You"} want optimal nutrition to support long and intense athletic training. (Minimal to no weight change desired.)`,
		// 	extendedBody: "To support the increased nutrient and energy demands of athletic performance, the calculator will provide a calorie intake that's 10% above the amount you need to maintain your weight. <br><br>This option is best suited for individuals who compete athletically at high levels and are extremely active. For example, your combined training and competition time exceeds 7 hours per week.<br><br>See your Complete Results PDF - available once your data has been calculated - for more guidance."
		// },
		{
			index: 2,
			imageUrl: bodyRecomp,
			title: "Body Recomposition",
			body: `${nutrical.userType === UserTypeE.Client ? "They" : "You"} want to lose less than 10 to 15 pounds of body fat, while simultaneously building muscle.`,
			extendedBody: "To facilitate simultaneous fat loss and muscle gain, the calculator will provide a calorie intake that's 10% below the amount you need to maintain your weight. <br><br>Body recomposition is best achieved by combining rigorous resistance training, appropriate levels of conditioning, and restorative activity (like yoga), along with quality sleep and stress management. This approach works best for folks who are deconditioned or have minimal training history.<br><br>See your Complete Results PDF - available once your data has been calculated - for more guidance."
		},
		// {
		// 	index: 4,
		// 	imageUrl: "https://www.precisionnutrition.com/hand_portion_calculator/assets/images/goal-improvehealth.svg",
		// 	title: "Improve Health",
		// 	body: ` ${nutrical.userType === UserTypeE.Client ? "They" : "You"} want to improve your nutrition and overall health, while maintaining your current weight.`,
		// 	extendedBody: "This goal is for individuals who want to improve their health through better nutrition. It's designed to provide appropriate macronutrient levels, portion sizes, and high-quality food choices.<br><br>The focus here is on health, energy and vitality, not physical change, so calories are set at maintenance levels, since weight change isn't the desired result.<br><br>The recommendations we provide to reach this goal are an educated starting point. See your Complete Results PDF - available once your data has been calculated - for more guidance."
		// },
	];

	const cardClicked = (index: number) => {
		goal.setReachGoal(index);
		setSelectedIndex(index);
		setEnabled(true);
	};

	React.useEffect(() => {
		if (typeof goal.reachGoal !== "undefined") {
			setEnabled(true);
		}
	}, []);

	const valueClicked = () => {
		AnalyticsApi.logEvent('Fitness Goal Selected');
		valueSelected();
	};

	return (
		<div className="content">
			<CardCotainer cardList={goals} selectedIndex={selectedIndex} valueSelected={cardClicked}></CardCotainer>

			<div className="">
				{enabled ? (
					<button className="greenButton" onClick={(e) => valueClicked()}>
						Next
					</button>
				) : (
					<button className="lightGrayButton">Next</button>
				)}
			</div>
		</div>
	);
};

export default Goal;
